import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300">
      {/* Main Footer Content */}
      <div className="border-b border-gray-700">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            {/* Left: Branding & Contact */}
            <div className="space-y-6">
              {/* Branding Section */}
              <div>
                <Link to="/" className="flex items-center gap-2 mb-3">
                  <img src="/assets/img/brand/logo-light.png" alt="Trademark Infinite" className="h-10 w-auto" />
                </Link>
                <p className="text-sm text-gray-400 leading-relaxed">
                  Safeguarding Innovation.<br />
                  Protecting Identity.
                </p>
              </div>

              {/* Contact Information */}
              <div className="space-y-3">
                <div className="flex items-start gap-2">
                  <MapPin size={16} className="text-orange-500 mt-1 flex-shrink-0" />
                  <p className="text-sm text-gray-400">
                    One Wilshire Building<br />
                    624 S Grand Ave Floor 21<br />
                    Los Angeles, CA 90017
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <Phone size={16} className="text-orange-500 flex-shrink-0" />
                  <a href="tel:+18882016668" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">
                    +1 (888) 201-6668
                  </a>
                </div>
                <div className="flex items-center gap-2">
                  <Mail size={16} className="text-orange-500 flex-shrink-0" />
                  <a href="mailto:info@trademarkinfinite.com" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">
                    info@trademarkinfinite.com
                  </a>
                </div>
              </div>
            </div>

            {/* Trademark Services */}
            <div>
              <h4 className="text-base font-semibold text-white mb-4">Trademark Services</h4>
              <ul className="space-y-2">
                <li><Link to="/services/trademark-registration" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Trademark Search & Registration</Link></li>
                <li><Link to="/services/trademark-clearance" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Trademark Clearance Searches</Link></li>
                <li><Link to="/services/trademark-application" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Trademark Application Preparation</Link></li>
                <li><Link to="/services/trademark-office-actions" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Trademark Office Actions</Link></li>
                <li><Link to="/services/trademark-monitoring" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Trademark Monitoring</Link></li>
                <li><Link to="/services/statement-of-use" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Statement Of Use Filings</Link></li>
                <li><Link to="/services/trademark-ownership-change" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Trademark Change of Ownership</Link></li>
                <li><Link to="/services/trademark-portfolio" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Trademark Portfolio Management</Link></li>
              </ul>
            </div>

            {/* Copyright Services */}
            <div>
              <h4 className="text-base font-semibold text-white mb-4">Copyright Services</h4>
              <ul className="space-y-2">
                <li><Link to="/services/copyright-registration" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Copyright Registration</Link></li>
                <li><Link to="/services/copyright-enforcement" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Copyright Enforcement</Link></li>
                <li><Link to="/services/copyright-assignments" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Copyright Assignments and Licensing</Link></li>
                <li><Link to="/services/copyright-litigation" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Copyright Litigation</Link></li>
                <li><Link to="/services/copyright-portfolio" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Copyright Portfolio Management</Link></li>
                <li><Link to="/services/dmca" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Digital Millennium Copyright Act</Link></li>
              </ul>
            </div>

            {/* Patent Services */}
            <div>
              <h4 className="text-base font-semibold text-white mb-4">Patent Services</h4>
              <ul className="space-y-2">
                <li><Link to="/services/patent-search" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Patent Searches</Link></li>
                <li><Link to="/services/patent-office-actions" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Office Actions & Amendments</Link></li>
                <li><Link to="/services/patent-applications" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Patent Applications</Link></li>
                <li><Link to="/services/patent-enforcement" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Patent Enforcement</Link></li>
              </ul>
            </div>

            {/* Company Formation */}
            <div>
              <h4 className="text-base font-semibold text-white mb-4">Company Formation</h4>
              <ul className="space-y-2">
                <li><Link to="/services/llc-formation" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">LLC Formation</Link></li>
                <li><Link to="/services/c-corporation" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">C Corporation</Link></li>
                <li><Link to="/services/s-corporation" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">S Corporation</Link></li>
                <li><Link to="/services/non-profit" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Non-Profit Organization</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer - Copyright & Legal Links */}
      <div className="bg-gray-900 py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © 2026 Trademark Infinite. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/privacy-policy" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};